import React, { useState } from 'react';
import { Button } from './ui/Button';
export function PartnerForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  return <section id="partner" className="py-24 bg-[#ecdfd2]/20 border-t border-[#ecdfd2]" data-id="element-122" data-mp="2idaj5b1y6d6d">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123" data-mp="2dfhcyi0n9j63">
        <div className="text-center mb-12" data-id="element-124" data-mp="2dh292c2lxa62">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3b2316] mb-4" data-id="element-125" data-mp="3a3x2wf7o1ujq">
            Join Us Next Year
          </h2>
          <p className="text-xl text-[#5a3a28]/80" data-id="element-126" data-mp="363wouvohbld7">
            This celebration was only possible because of our community partners
            who served as judges and sponsors. If you'd like to be part of the
            2027 celebration, tell us below and we'll be in touch in the spring.
          </p>
        </div>

        {status === 'success' ? <div className="bg-[#c06a2b]/10 p-8 rounded-lg text-center border border-[#c06a2b]/20" data-id="element-127" data-mp="3p1pif7d7qixx">
            <h3 className="text-2xl font-bold text-[#c06a2b] mb-4" data-id="element-128" data-mp="6rvch36epvl5">
              Thank you for your interest.
            </h3>
            <p className="text-[#5a3a28] mb-6" data-id="element-129" data-mp="bq581ew1my7a">
              We have received your inquiry and will be in touch shortly to
              discuss how we can work together.
            </p>
            <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-130" data-mp="20ln83orsu9s">
              Send Another Message
            </Button>
          </div> : status === 'error' ? <div className="bg-red-50 p-8 rounded-lg text-center border border-red-200" data-id="element-131" data-mp="3p6w4dznwwrmo">
            <h3 className="text-2xl font-bold text-red-700 mb-4" data-id="element-132" data-mp="3b6v4amfh1o89">
              Something went wrong
            </h3>
            <p className="text-[#5a3a28] mb-6" data-id="element-133" data-mp="3f7nh1pnjyb9a">
              We couldn't send your message. Please try again or email us
              directly at{' '}
              <a href="mailto:info@goodfatherproject.org" className="text-[#c06a2b] hover:underline" data-id="element-134" data-mp="19d469u2dwe7a">
                info@goodfatherproject.org
              </a>
            </p>
            <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-135" data-mp="2hexiw4c2ioj3">
              Try Again
            </Button>
          </div> : <form action="https://formsubmit.co/travishellstrom@gmail.com" method="POST" className="space-y-6 bg-white p-8 md:p-12 rounded-lg border border-[#ecdfd2] shadow-sm" data-id="element-136" data-mp="2ddvkfppz6gi6">
            {/* FormSubmit configuration */}
            <input type="hidden" name="_subject" value="New Partnership Inquiry - Good Father Project" data-id="element-137" data-mp="312516d8c0e2g" />
            <input type="hidden" name="_captcha" value="false" data-id="element-138" data-mp="2w9u1nbhi6uaf" />
            <input type="hidden" name="_template" value="table" data-id="element-139" data-mp="2rc29cgcy565p" />

            <div className="grid md:grid-cols-2 gap-6" data-id="element-140" data-mp="3osr79yyrzo9t">
              <div className="space-y-2" data-id="element-141" data-mp="3ouc1fnh6h575">
                <label htmlFor="orgName" className="block text-sm font-medium text-[#3b2316]" data-id="element-142" data-mp="3k0zc1b4ocudc">
                  Organization Name
                </label>
                <input type="text" id="orgName" name="Organization" required className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all" placeholder="Local organization" data-id="element-143" data-mp="5ks3m2y4r7t" />
              </div>

              <div className="space-y-2" data-id="element-144" data-mp="j3xdq7b1ntka">
                <label htmlFor="contactName" className="block text-sm font-medium text-[#3b2316]" data-id="element-145" data-mp="j2vqz5ko1imq">
                  Contact Name
                </label>
                <input type="text" id="contactName" name="Name" required className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all" placeholder="Your full name" data-id="element-146" data-mp="wwn1ag6816ji" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-147" data-mp="xzc44bq49yd3">
              <label htmlFor="email" className="block text-sm font-medium text-[#3b2316]" data-id="element-148" data-mp="xy0xm45aecia">
                Email Address
              </label>
              <input type="email" id="email" name="Email" required className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all" placeholder="name@organization.org" data-id="element-149" data-mp="5an8gs7tyl8q" />
            </div>

            <div className="space-y-2" data-id="element-150" data-mp="1qm6hypsfhzhl">
              <label htmlFor="message" className="block text-sm font-medium text-[#3b2316]" data-id="element-151" data-mp="1qpawafzlyblz">
                Message
              </label>
              <textarea id="message" name="Message" required rows={4} className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us how you'd like to partner..." data-id="element-152" data-mp="33o4e6yybhknu" />
            </div>

            <div className="pt-4" data-id="element-153" data-mp="3rbks2wku5cv9">
              <Button type="submit" className="w-full md:w-auto" data-id="element-154" data-mp="3raj822ludg1e">
                Send
              </Button>
            </div>
          </form>}
      </div>
    </section>;
}